// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"49d4f78c","455":"73a52339","977":"8bb956af"}[chunkId] + ".chunk.js";
};